import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import GlobalStyles from "./components/GlobalStyles";

// ------ ReactDOM - 17.

// ReactDOM.render(
//     <React.StrictMode>
//         <GlobalStyles>
//             <App />
//         </GlobalStyles>
//     </React.StrictMode>,
//     document.getElementById("root")
// );

// ------ ReactDOM - 18.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Router>
        <GlobalStyles>
            <App />
        </GlobalStyles>
    </Router>
);
